import { scrollIntoView } from "../Helpers/scrollTo";

const vxLogo = require("./../../Img/logo.svg");

export const Floatinglogo = () => {
    return (
        <div className="floating-logo" onClick={() => scrollIntoView('form_container')}>
            <img src={vxLogo} alt="Logo" />
            <span className="font-size-1">VIP Club</span>
        </div>
    )
}